webpackJsonp([1],{

/***/ "+C/r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EB = __webpack_require__("NF5n");

var _EB2 = _interopRequireDefault(_EB);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var barcodeOptions = {
  allDecoders: false,
  code128: true,
  code128securityLevel: 0,
  code39: true,
  code39securityLevel: 0,
  datamatrix: true,
  aimType: _EB2.default.Barcode.AIMTYPE_TRIGGER, // AIMTYPE_CONTINUOUS_READ
  decodeFrequency: 2000,
  decodeLEDFeedback: true,
  decodeLEDFeedbackMode: _EB2.default.Barcode.LEDMODE_BOTH,
  decodeLEDTime: 300,
  decodeVolume: 5,
  decodeDuration: 200,
  hapticFeedback: true,
  lcdMode: true,
  sameSymbolTimeout: 3000,
  differentSymbolTimeout: 0
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  created: function created() {
    if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
      this.scannerType = 'zebra';
      this.initializeScanner();

      _EB2.default.Application.setApplicationNotify(this.onZebraApplicationDestroy);
    } else {
      this.scannerType = 'software';
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
      if (this.scanner) {
        this.scanner.disable();
        this.scanner = null;
      }
    }
  },
  data: function data() {
    return {
      item: null,
      error: null,
      barcode: null,
      scannerType: null,
      debug: null,
      scanner: null
    };
  },

  computed: {},
  methods: {
    initializeScanner: function initializeScanner() {
      var _this = this;

      _EB2.default.Barcode.enumerate(function (scanners) {
        if (scanners.length === 0) {
          _this.error = 'Geen barcode scanner gevonden';
          return;
        }

        _this.scanner = scanners[0];
        _this.scanner.enable(barcodeOptions, _this.zebraBarcodeScanned);
      });
    },
    onZebraApplicationDestroy: function onZebraApplicationDestroy(event) {
      switch (event.applicationEvent) {
        case _EB2.default.Application.APP_EVENT_ACTIVATED:
        case _EB2.default.Application.APP_EVENT_UICREATED:
        case _EB2.default.Application.APP_EVENT_SCREEN_ON:
          this.initializeScanner();
          console.log('activated scanner 2');
          break;
        case _EB2.default.Application.APP_EVENT_SCREEN_OFF:
        case _EB2.default.Application.APP_EVENT_UIDESTROYED:
        case _EB2.default.Application.APP_EVENT_DEACTIVATED:
          console.log('disabled scanner 2');
          if (this.scanner) {
            this.scanner.disable();
            this.scanner = null;
          }
          break;
      }
    },
    zebraBarcodeScanned: function zebraBarcodeScanned(barcode) {
      this.fetchProductInfo(barcode.data);
    },
    fetchProductInfo: function fetchProductInfo(barcode) {
      var _this2 = this;

      this.barcode = barcode;
      this.item = null;
      this.error = null;

      this.$http.get("https://scan-api.productie-test.drbanket.nl" + '/production-receipt/' + barcode).then(function (response) {
        _this2.item = response.body;
      }, function (response) {
        if (response.status === 0) {
          _this2.error = 'Kan geen informatie ophalen vanaf de server, controleer de internetverbinding.';
        } else if (response.status === 404) {
          _this2.error = 'Geen informatie gevonden voor ' + barcode + '.';
        } else {
          _this2.error = 'Er heeft zich een onbekende fout voorgedaan voor ' + barcode + '.';
        }
        // do nothing
      });
    },
    getProductionStatusBadge: function getProductionStatusBadge(item) {
      switch (item.productionStatus) {
        case 'new':
          return '<span class="badge badge-production-status badge-new">Nieuw</span>';
        case 'cancelled':
          return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>';
        case 'preparing_for_production':
        case 'in_production':
          return '<span class="badge badge-production-status badge-in-production">In productie</span>';
        case 'produced':
          if (item.packingStatus === 'packed') {
            return '<span class="badge badge-production-status badge-packed">Ingepakt</span>';
          }

          return '<span class="badge badge-production-status badge-produced">Geproduceerd</span>';
        default:
          return item.productionStatus;
      }
    },
    getPrintStatusBadge: function getPrintStatusBadge(status) {
      switch (status) {
        case 'unprinted':
          return '<span class="badge badge-production-status badge-unprinted">Niet geprint</span>';
        case 'preparing':
          return '<span class="badge badge-production-status badge-printing">Wordt geprint...</span>';
        case 'printed':
          return '<span class="badge badge-production-status badge-printed">Geprint</span>';
        default:
          return status;
      }
    }
  }
};

/***/ }),

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__);
/* unused harmony namespace reexport */
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("gRbd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/bootstrap-vue/es/components/table/table.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25aff2b6", Component.options)
  } else {
    hotAPI.reload("data-v-25aff2b6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/Put":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _table = __webpack_require__("fnDg");

var _table2 = _interopRequireDefault(_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _table2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "/S/K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  created: function created() {
    this.refreshUsers();
  },
  beforeDestroy: function beforeDestroy() {},
  data: function data() {
    return {
      firstLetter: null,
      users: [],
      code: '',
      user: null,
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    };
  },

  computed: {
    selectedUsers: function selectedUsers() {
      var users = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.users), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var user = _step.value;

          if (user.firstName.substr(0, 1).toUpperCase() === this.firstLetter) {
            users.push(user);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return users;
    },
    possibleLetters: function possibleLetters() {
      var possibleLetters = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.users), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var user = _step2.value;

          var firstLetter = user.firstName.substring(0, 1).toUpperCase();

          if (possibleLetters.indexOf(firstLetter) === -1) {
            possibleLetters.push(firstLetter);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return possibleLetters;
    }
  },
  methods: {
    refreshUsers: function refreshUsers() {
      var _this = this;

      this.$http.get("https://scan-api.productie-test.drbanket.nl" + '/users', { withCredentials: true }).then(function (response) {
        _this.users = response.body;
      }, function (response) {
        if (response.body.errors) {
          _this.error = response.body.errors.join(',');
        } else {
          _this.error = 'Onverwachte fout, probeer het later opnieuw';
        }
      });
    },
    selectFirstLetter: function selectFirstLetter(letter) {
      if (this.possibleLetters.indexOf(letter) !== -1) {
        this.firstLetter = letter;
      }
    },
    selectUser: function selectUser(user) {
      this.user = user;
    },
    selectNumberCode: function selectNumberCode(number) {
      var _this2 = this;

      this.code = this.code + number;

      if (this.code.length === 5) {
        this.$store.dispatch('authenticate', { code: this.code, username: this.user.username }).then(function () {
          _this2.user = null;
          _this2.firstLetter = null;
          _this2.code = '';
        }, function () {
          _this2.code = '';
        });
      }
    },
    removeNumberCode: function removeNumberCode() {
      if (this.code.length > 0) {
        this.code = this.code.substr(0, -1);
      }
    }
  }
};

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1F9u":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\na[data-v-beffe230]:hover {\n  cursor: pointer;\n}\n.main-menu[data-v-beffe230] {\n  padding-top: 15px;\n}\n.btn-full-width[data-v-beffe230] {\n  width: 100%;\n}\n.btn[data-v-beffe230] {\n  cursor: pointer;\n  border-radius: 0;\n}\n.menu-item[data-v-beffe230] {\n  margin-bottom: 15px;\n}\n.btn-first-line[data-v-beffe230] {\n  font-size: 10px;\n  line-height: 10px;\n  vertical-align: top;\n}\n.btn-primary-line[data-v-beffe230] {\n  font-size: 20px;\n  line-height: 26px;\n  vertical-align: top;\n}\n.btn-produced[data-v-beffe230] {\n  background-color: #ff8535;\n  color: #fff;\n}\n.btn-pick[data-v-beffe230] {\n  background-color: #28a745;\n  color: #fff;\n}\n.btn-item-info[data-v-beffe230],\n.btn-shipping-info[data-v-beffe230] {\n  background-color: #17a2b8;\n  color: #fff;\n}\n", ""]);

// exports


/***/ }),

/***/ "1Ymb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [
        _vm._v("INPAKKEN")
      ]),
      _vm._v(" "),
      !_vm.barcode && !_vm.packingSlip && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _vm._v(
                "\n        Scan een barcode van een pakbon om deze in te pakken.\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.debug
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.debug) + "\n      ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.packingSlip && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("span", { staticClass: "item-loader float-left" }),
              _vm._v(
                " Ophalen informatie " + _vm._s(_vm.barcode) + "...\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && _vm.packingSlip && !_vm.error
        ? _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("div", { staticClass: "product-info" }, [
                _c("table", [
                  _c("tr", [
                    _c("th", [_vm._v("Status")]),
                    _vm._v(" "),
                    _c("td", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getPickingStatusBadge(
                            _vm.packingSlip.pickingStatus
                          )
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Barcode")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.packingSlip.barcode))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Ingepakt")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.numPicked) +
                          " / " +
                          _vm._s(_vm.packingSlip.items.length)
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.packingSlip.items, function(item) {
                return _c("div", { staticClass: "product-info" }, [
                  _c("div", { staticClass: "product-info-cols" }, [
                    _c("div", { staticClass: "product-info-first-col" }, [
                      item.productionReceipt.localReceiptInfo
                        ? _c(
                            "span",
                            {
                              staticClass: "sequence-number",
                              class: _vm.getPickingStatusSequenceColorClass(
                                item.packingStatus
                              )
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.productionReceipt.localReceiptInfo
                                    .sequenceNumber
                                )
                              )
                            ]
                          )
                        : _c("span", {
                            staticClass: "sequence-number",
                            class: _vm.getPickingStatusSequenceColorClass(
                              item.packingStatus
                            )
                          }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.getPackingStatusBadge(item.packingStatus)
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "barcode" }, [
                        _vm._v(_vm._s(item.productionReceipt.barcode))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-info-second-col" }, [
                      _c("span", {
                        staticClass: "product-info-item-badge",
                        domProps: {
                          innerHTML: _vm._s(_vm.getProductionStatusBadge(item))
                        }
                      }),
                      _c("br"),
                      _vm._v(" "),
                      _c("table", [
                        _c("tr", [
                          _c("td", { attrs: { colspan: "2" } }, [
                            _vm._v(
                              _vm._s(item.product.productName) +
                                " " +
                                _vm._s(item.variation.variationName)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("Productie:")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  item.productionDate,
                                  "DD-MM-YYYY"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("Aflevering:")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  item.deliveryDate,
                                  "DD-MM-YYYY"
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.packingSlip && _vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9329428", esExports)
  }
}

/***/ }),

/***/ "2u8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanProduced_vue__ = __webpack_require__("3Ntv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanProduced_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanProduced_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanProduced_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanProduced_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6b6e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanProduced_vue__ = __webpack_require__("eQr8");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("TsXW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab6b6e5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanProduced_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6b6e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanProduced_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ScanProduced.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ab6b6e5e", Component.options)
  } else {
    hotAPI.reload("data-v-ab6b6e5e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3Ntv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _EB = __webpack_require__("NF5n");

var _EB2 = _interopRequireDefault(_EB);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var barcodeOptions = {
  allDecoders: false,
  code128: true,
  code128securityLevel: 0,
  code39: true,
  code39securityLevel: 0,
  datamatrix: true,
  aimType: _EB2.default.Barcode.AIMTYPE_CONTINUOUS_READ, // AIMTYPE_TRIGGER
  decodeFrequency: 2000,
  decodeLEDFeedback: true,
  decodeLEDFeedbackMode: _EB2.default.Barcode.LEDMODE_BOTH,
  decodeLEDTime: 300,
  decodeVolume: 5,
  decodeDuration: 200,
  hapticFeedback: true,
  lcdMode: true,
  sameSymbolTimeout: 500,
  differentSymbolTimeout: 0
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  created: function created() {
    if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
      this.scannerType = 'zebra';

      _EB2.default.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned);
      _EB2.default.Application.setApplicationNotify(this.onZebraApplicationDestroy);
    } else {
      this.scannerType = 'software';
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
      _EB2.default.Barcode.disable();
    }
  },
  data: function data() {
    return {
      items: [],
      fetchingItems: [],
      scannerType: null,
      debug: null,
      numScannedTwice: 0
    };
  },

  computed: {
    numErrors: function numErrors() {
      var numErrors = 0;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.error) {
            numErrors++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return numErrors;
    }
  },
  methods: {
    onZebraApplicationDestroy: function onZebraApplicationDestroy(event) {
      switch (event.applicationEvent) {
        case _EB2.default.Application.APP_EVENT_ACTIVATED:
        case _EB2.default.Application.APP_EVENT_UICREATED:
        case _EB2.default.Application.APP_EVENT_SCREEN_ON:
          _EB2.default.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned);
          break;
        case _EB2.default.Application.APP_EVENT_SCREEN_OFF:
        case _EB2.default.Application.APP_EVENT_UIDESTROYED:
        case _EB2.default.Application.APP_EVENT_DEACTIVATED:
          _EB2.default.Barcode.disable();
          break;
      }
    },
    zebraBarcodeScanned: function zebraBarcodeScanned(barcode) {
      this.changeItemStatus(barcode.data);
    },
    changeItemStatus: function changeItemStatus(barcode) {
      // check if the barcode is already scanned this session
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.fetchingItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var fetchingBarcode = _step2.value;

          if (fetchingBarcode === barcode) {
            this.numScannedTwice++;
            return;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      for (var x in this.items) {
        if (this.items[x].barcode === barcode) {
          var removed = this.items.splice(x, 1);

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (0, _getIterator3.default)(removed), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var reAdd = _step3.value;

              this.items.unshift(reAdd);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          this.numScannedTwice++;
          return;
        }
      }

      this.fetchingItems.push(barcode);
      this.updateProductionStatus({
        barcode: barcode,
        attempt: 0
      });
    },
    updateProductionStatus: function updateProductionStatus(info) {
      var _this = this;

      this.$http.patch("https://scan-api.productie-test.drbanket.nl" + '/production-receipt/' + info.barcode + '/production-status', {
        productionStatus: 'produced'
      }).then(function (response) {
        for (var x in _this.fetchingItems) {
          if (_this.fetchingItems[x] === info.barcode) {
            _this.fetchingItems.splice(x, 1);
          }
        }

        _this.items.unshift({
          barcode: info.barcode,
          item: response.body
        });
      }, function (response) {
        if (response.status === 0) {
          if (info.attempt < 3) {
            setTimeout(function () {
              _this.updateProductionStatus({
                barcode: info.barcode,
                attempt: info.attempt + 1
              });
            }, 3000 * (info.attempt + 1));

            return;
          }
        }

        for (var x in _this.fetchingItems) {
          if (_this.fetchingItems[x] === info.barcode) {
            _this.fetchingItems.splice(x, 1);
          }
        }

        var error = 'Er heeft zich een onbekende fout voorgedaan';

        if (response.status === 0) {
          error = 'Kan geen informatie ophalen vanaf de server, controleer de internetverbinding.';
        } else if (response.status === 404) {
          error = 'Geen informatie gevonden voor ' + info.barcode + '.';
        } else if (response.status === 412) {
          error = response.body.errors.join(', ');
        }

        _this.items.unshift({
          barcode: info.barcode,
          error: error
        });
      });
    },
    getProductionStatusBadge: function getProductionStatusBadge(item) {
      switch (item.productionStatus) {
        case 'new':
          return '<span class="badge badge-production-status badge-new">Nieuw</span>';
        case 'cancelled':
          return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>';
        case 'preparing_for_production':
        case 'in_production':
          return '<span class="badge badge-production-status badge-in-production">In productie</span>';
        case 'produced':
          if (item.packingStatus === 'packed') {
            return '<span class="badge badge-production-status badge-packed">Ingepakt</span>';
          }

          return '<span class="badge badge-production-status badge-produced-scan">Geproduceerd</span>';
        default:
          return item.productionStatus;
      }
    }
  }
};

/***/ }),

/***/ "4PwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAuthentication_vue__ = __webpack_require__("/S/K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAuthentication_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAuthentication_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAuthentication_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAuthentication_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a7153d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAuthentication_vue__ = __webpack_require__("calG");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("MOIw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a7153d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAuthentication_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a7153d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAuthentication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/UserAuthentication.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a7153d3", Component.options)
  } else {
    hotAPI.reload("data-v-3a7153d3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5bIc":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n/*\n * Temporary fix, as BS V4.beta.2 mistakenly removed progress-bar transition.\n * This should be able to be removed once V4.beta.3 is released.\n * And this full component can be moved into the progress.js file\n */\n.progress-bar {\n    -webkit-transition: width .6s ease;\n    transition: width .6s ease;\n}\n", ""]);

// exports


/***/ }),

/***/ "6gam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanPacking_vue__ = __webpack_require__("RpPf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanPacking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanPacking_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanPacking_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanPacking_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9329428_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanPacking_vue__ = __webpack_require__("1Ymb");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("kIf6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b9329428"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanPacking_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9329428_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanPacking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ScanPacking.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b9329428", Component.options)
  } else {
    hotAPI.reload("data-v-b9329428", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7bLt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n/* Custom-file focus styling: These can possibly be removed once BSV4.beta.3 is released */\n/* Although the focus handling/style will still be needed for Firefox keyboard-only users */\n/* Which will be addressed if PR https://github.com/twbs/bootstrap/pull/24138 is merged */\n\n/* Regular focus styling */\n.b-form-file.custom-file .custom-file-input.focus ~ .custom-file-control,\n.b-form-file.custom-file .custom-file-input:focus ~ .custom-file-control {\n    color: #495057;\n    background-color: #fff;\n    border-color: #80bdff;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n    outline: none;\n}\n/* Invalid focus styling */\n.b-form-file.custom-file .custom-file-input.is-invalid.focus ~ .custom-file-control,\n.b-form-file.custom-file .custom-file-input.is-invalid:focus ~ .custom-file-control,\n.was-validated .b-form-file.custom-file .custom-file-input:invalid.focus ~ .custom-file-control,\n.was-validated .b-form-file.custom-file .custom-file-input:invalid:focus ~ .custom-file-control {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n            box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n    border-color: #dc3545;\n}\n/* valid focus styling */\n.b-form-file.custom-file .custom-file-input.is-valid.focus ~ .custom-file-control,\n.b-form-file.custom-file .custom-file-input.is-valid:focus ~ .custom-file-control,\n.was-validated .b-form-file.custom-file .custom-file-input:valid.focus ~ .custom-file-control,\n.was-validated .b-form-file.custom-file .custom-file-input:valid:focus ~ .custom-file-control {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n            box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n    border-color: #28a745;\n}\n\n/* Interim fix (until BS V4.beta.3) for is-{state} feedback for plain form-file input */\n/* See issue https://github.com/twbs/bootstrap/issues/24831 */\n.form-control-file.is-invalid ~ .invalid-feedback,\n.form-control-file.is-valid ~ .valid-feedback,\n.was-validated .form-control-file:invalid ~ .invalid-feedback,\n.was-validated .form-control-file:valid ~ .valid-feedback {\n    display: block;\n}\n\n/* Drag/Drop and filenames/prompts custom styling */\n.b-form-file.custom-file .custom-file-control {\n    overflow: hidden;\n}\n.b-form-file.custom-file .custom-file-control {\n    overflow: hidden;\n}\n.b-form-file.custom-file .custom-file-control.dragging {\n    overflow: hidden;\n    -webkit-filter: blur(3px);\n            filter: blur(3px);\n}\n.b-form-file.custom-file .custom-file-control[data-selected]::after {\n    content: attr(data-selected);\n}\n.b-form-file.custom-file .custom-file-control[data-choose]::before {\n    content: attr(data-choose);\n}\n.b-form-file.custom-file .drop-here {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, .5);\n    border-radius: 3px;\n    z-index: 99999;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.b-form-file.custom-file .drop-here::before {\n    color: white;\n    content: attr(data-drop);\n}\n", ""]);

// exports


/***/ }),

/***/ "8aCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionItemInfo_vue__ = __webpack_require__("+C/r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionItemInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionItemInfo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionItemInfo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionItemInfo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4596736a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductionItemInfo_vue__ = __webpack_require__("u65/");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("yel6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4596736a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionItemInfo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4596736a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductionItemInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ProductionItemInfo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4596736a", Component.options)
  } else {
    hotAPI.reload("data-v-4596736a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9WQX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5bIc");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0cddfa51", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-395cfa78\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./progress.vue", function() {
     var newContent = require("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-395cfa78\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./progress.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AJ8v":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n/*\n  This CSS can be removed once Bootstrap V4.beta.3 is released\n  https://github.com/twbs/bootstrap/pull/24510\n  Once BSV4.beta.3 is released, the script section can be moved into the modal.js file\n  V4.beta.3 will be changing modal margin to rem units\n*/\n.modal-dialog-centered {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    /* min-height: calc(100% - (1rem * 2)); */\n    min-height: calc(100% - (10px * 2));\n}\n.modal-dialog-centered .modal-content {\n    width: 100%;\n}\n@media (min-width: 576px) {\n.modal-dialog-centered {\n        /* min-height: calc(100% - (1.75rem * 2)); */\n        min-height: calc(100% - (30px * 2));\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "EDhK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\na[data-v-3a7153d3]:hover {\n  cursor: pointer;\n}\n.module-title[data-v-3a7153d3] {\n  background-color: #ff8535;\n  color: #fff;\n  font-size: 20px;\n  line-height: 40px;\n}\na[data-v-3a7153d3]:hover {\n  cursor: pointer;\n}\n.name-description[data-v-3a7153d3] {\n  background-color: #fff;\n  margin-top: 15px;\n  padding: 10px;\n  width: 100%;\n  font-size: 16px;\n  font-weight: bold;\n  text-align: center;\n}\n.user-username[data-v-3a7153d3] {\n  background-color: #fff;\n  margin-top: 15px;\n  padding: 15px;\n  width: 100%;\n  font-size: 16px;\n  text-align: center;\n}\n.product-info table[data-v-3a7153d3] {\n  width: 100%;\n}\n.code[data-v-3a7153d3] {\n}\n.code-box[data-v-3a7153d3] {\n  background-color: #eee;\n  display: inline-block;\n  height: 35px;\n  width: 35px;\n  margin-left: 10px;\n  margin-right: 10px;\n  font-size: 35px;\n  line-height: 45px;\n  overflow: hidden;\n  color: #000;\n}\n.number-input-block[data-v-3a7153d3] {\n  height: 50vh;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border-top: 1px solid #ddd;\n}\n.number-input-block table[data-v-3a7153d3] {\n  border-spacing: 3px;\n  border: 1px solid #fff;\n  border-collapse: separate;\n}\ntd.number-input-control[data-v-3a7153d3] {\n  border: 1px solid #fff;\n  border-collapse: separate;\n  width: 33%;\n  vertical-align: middle;\n  padding: 2px;\n  font-size: 20px;\n  background-color: #ff8535;\n  color: #fff;\n}\n.letter-container[data-v-3a7153d3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  top: -40px;\n  padding-top: 113px;\n  padding-bottom: 15px;\n  position: absolute;\n  left: 15px;\n  right: 15px;\n  height: 100vh;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-line-pack: justify;\n      align-content: space-between;\n  overflow: hidden;\n}\n.letter-box[data-v-3a7153d3] {\n  display: block;\n  width: 25%;\n  height: 14.27%;\n  padding: 5px;\n  vertical-align: middle;\n  position: relative;\n}\n.letter-btn.available[data-v-3a7153d3] {\n  background-color: #ff8535;\n}\n.letter-btn[data-v-3a7153d3] {\n  width: 100%;\n  height: 100%;\n  color: #fff;\n  font-size: 30px;\n  font-weight: bold;\n  text-align: center;\n  display: inline-block;\n  line-height: calc(100%);\n}\n@media (orientation: landscape) {\n.letter-box[data-v-3a7153d3] {\n    width: 14.27vw;\n    height: 25vh;\n}\n}\n.product-info table td[data-v-3a7153d3],\n.product-info table th[data-v-3a7153d3] {\n  vertical-align: top;\n}\n", ""]);

// exports


/***/ }),

/***/ "HCfX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\na[data-v-4596736a]:hover {\n  cursor: pointer;\n}\n.product-info[data-v-4596736a] {\n  background-color: #fff;\n  margin-top: 15px;\n  padding: 10px;\n  width: 100%;\n}\n.product-info table[data-v-4596736a] {\n  width: 100%;\n}\n.product-info table td[data-v-4596736a],\n.product-info table th[data-v-4596736a] {\n  vertical-align: top;\n}\n.product-info.error[data-v-4596736a] {\n  background-color: #dc3545;\n  color: #fff;\n}\n.module-title[data-v-4596736a] {\n  background-color: #17a2b8;\n  color: #fff;\n  font-size: 20px;\n  line-height: 40px;\n}\n", ""]);

// exports


/***/ }),

/***/ "HFaD":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dYJE");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0736309d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32d1e6d7\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PackingSlipInfo.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32d1e6d7\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PackingSlipInfo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__);
/* unused harmony namespace reexport */
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Tpvn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/bootstrap-vue/es/components/form-input/form-input.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23cbccf8", Component.options)
  } else {
    hotAPI.reload("data-v-23cbccf8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Iwyp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackingSlipInfo_vue__ = __webpack_require__("K6Ss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackingSlipInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackingSlipInfo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackingSlipInfo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackingSlipInfo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d1e6d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackingSlipInfo_vue__ = __webpack_require__("jxW3");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("HFaD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32d1e6d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackingSlipInfo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d1e6d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackingSlipInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/PackingSlipInfo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32d1e6d7", Component.options)
  } else {
    hotAPI.reload("data-v-32d1e6d7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__);
/* unused harmony namespace reexport */
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Mu/A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/bootstrap-vue/es/components/modal/modal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c55dc398", Component.options)
  } else {
    hotAPI.reload("data-v-c55dc398", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__);
/* unused harmony namespace reexport */
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("OH6C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/bootstrap-vue/es/components/form-file/form-file.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23b234a4", Component.options)
  } else {
    hotAPI.reload("data-v-23b234a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "K6Ss":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _EB = __webpack_require__("NF5n");

var _EB2 = _interopRequireDefault(_EB);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var barcodeOptions = {
  allDecoders: false,
  code128: true,
  code128securityLevel: 0,
  code39: true,
  code39securityLevel: 0,
  datamatrix: true,
  aimType: _EB2.default.Barcode.AIMTYPE_TRIGGER, // AIMTYPE_CONTINUOUS_READ
  decodeFrequency: 2000,
  decodeLEDFeedback: true,
  decodeLEDFeedbackMode: _EB2.default.Barcode.LEDMODE_BOTH,
  decodeLEDTime: 300,
  decodeVolume: 5,
  decodeDuration: 200,
  hapticFeedback: true,
  lcdMode: true,
  sameSymbolTimeout: 3000,
  differentSymbolTimeout: 0
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  created: function created() {
    if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
      this.scannerType = 'zebra';

      _EB2.default.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned);
      _EB2.default.Application.setApplicationNotify(this.onZebraApplicationDestroy);
    } else {
      this.scannerType = 'software';
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
      _EB2.default.Barcode.disable();
    }
  },
  data: function data() {
    return {
      packingSlip: null,
      error: null,
      barcode: null,
      scannerType: null,
      debug: null
    };
  },

  computed: {
    numPicked: function numPicked() {
      var numPicked = 0;

      if (!this.packingSlip) {
        return numPicked;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.packingSlip.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.packingStatus === 'picked' || item.packingStatus === 'packed') {
            ++numPicked;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return numPicked;
    }
  },
  methods: {
    onZebraApplicationDestroy: function onZebraApplicationDestroy(event) {
      switch (event.applicationEvent) {
        case _EB2.default.Application.APP_EVENT_ACTIVATED:
        case _EB2.default.Application.APP_EVENT_UICREATED:
        case _EB2.default.Application.APP_EVENT_SCREEN_ON:
          _EB2.default.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned);
          console.log('activated scanner 2');
          break;
        case _EB2.default.Application.APP_EVENT_SCREEN_OFF:
        case _EB2.default.Application.APP_EVENT_UIDESTROYED:
        case _EB2.default.Application.APP_EVENT_DEACTIVATED:
          _EB2.default.Barcode.disable();
          console.log('disabled scanner 2');
          break;
      }
    },
    zebraBarcodeScanned: function zebraBarcodeScanned(barcode) {
      this.fetchPackingSlipInfo(barcode.data);
    },
    fetchPackingSlipInfo: function fetchPackingSlipInfo(barcode) {
      var _this = this;

      this.barcode = barcode;
      this.packingSlip = null;
      this.error = null;

      this.$http.get("https://scan-api.productie-test.drbanket.nl" + '/packing-slip/' + barcode).then(function (response) {
        _this.packingSlip = response.body;
      }, function (response) {
        if (response.status === 0) {
          _this.error = 'Kan geen informatie ophalen vanaf de server, controleer de internetverbinding.';
        } else if (response.status === 404) {
          _this.error = 'Geen informatie gevonden voor ' + barcode + '.';
        } else {
          _this.error = 'Er heeft zich een onbekende fout voorgedaan voor ' + barcode + '.';
        }
        // do nothing
      });
    },
    getProductionStatusBadge: function getProductionStatusBadge(item) {
      switch (item.productionStatus) {
        case 'new':
          return '<span class="badge badge-production-status badge-new">Nieuw</span>';
        case 'cancelled':
          return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>';
        case 'preparing_for_production':
        case 'in_production':
          return '<span class="badge badge-production-status badge-in-production">In productie</span>';
        case 'produced':
          if (item.packingStatus === 'packed') {
            return '<span class="badge badge-production-status badge-packed">Ingepakt</span>';
          }

          return '<span class="badge badge-production-status badge-produced">Geproduceerd</span>';
        default:
          return item.productionStatus;
      }
    },
    getPickingStatusSequenceColorClass: function getPickingStatusSequenceColorClass(status) {
      switch (status) {
        case 'picked':
        case 'packed':
          return 'picked';
        default:
          return 'unpicked';
      }
    },
    getPackingStatusBadge: function getPackingStatusBadge(status) {
      switch (status) {
        case 'not_produced':
          return '<span class="badge badge-production-status badge-new">Nieuw</span>';
        case 'unpicked':
          return '<span class="badge badge-production-status badge-in-production">Verzamelen...</span>';
        case 'picked':
          return '<span class="badge badge-production-status badge-produced">Verzameld</span>';
        case 'packed':
          return '<span class="badge badge-production-status badge-packed">Ingepakt</span>';
        case 'cancelling':
          return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>';
        case 'cancelled':
          return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>';
        default:
          return status;
      }
    },
    getPickingStatusBadge: function getPickingStatusBadge(status) {
      switch (status) {
        case 'not_started':
          return '<span class="badge badge-production-status badge-new">Nieuw</span>';
        case 'picking':
          return '<span class="badge badge-production-status badge-produced">Verzamelen...</span>';
        case 'picked':
          return '<span class="badge badge-production-status badge-packed">Ingepakt</span>';
        default:
          return status;
      }
    },
    getPrintStatusBadge: function getPrintStatusBadge(status) {
      switch (status) {
        case 'unprinted':
          return '<span class="badge badge-production-status badge-unprinted">Niet geprint</span>';
        case 'preparing':
          return '<span class="badge badge-production-status badge-printing">Wordt geprint...</span>';
        case 'printed':
          return '<span class="badge badge-production-status badge-printed">Geprint</span>';
        default:
          return status;
      }
    }
  }
};

/***/ }),

/***/ "KQyE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\na[data-v-b9329428]:hover {\n  cursor: pointer;\n}\n.module-title[data-v-b9329428] {\n  background-color: #28a745;\n  color: #fff;\n  font-size: 20px;\n  line-height: 40px;\n}\na[data-v-b9329428]:hover {\n  cursor: pointer;\n}\n.product-info[data-v-b9329428] {\n  background-color: #fff;\n  margin-top: 15px;\n  padding: 10px;\n  width: 100%;\n}\n.product-info table[data-v-b9329428] {\n  width: 100%;\n}\n.product-info table td[data-v-b9329428],\n.product-info table th[data-v-b9329428] {\n  vertical-align: top;\n}\n.product-info.error[data-v-b9329428] {\n  background-color: #dc3545;\n  color: #fff;\n}\n.sequence-number[data-v-b9329428] {\n  display: inline-block;\n  font-size: 40px;\n  font-weight: bold;\n  line-height: 100px;\n  width: 100px;\n  height: 100px;\n  text-align: center;\n}\n.sequence-number.unpicked[data-v-b9329428] {\n  background-color: #ff9999;\n  color: #000;\n}\n.sequence-number.picked[data-v-b9329428] {\n  background-color: #99ff99;\n  color: #000;\n}\n.product-info-cols[data-v-b9329428] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.product-info-first-col[data-v-b9329428] {\n  width: 100px;\n  text-align: center;\n  float: left;\n  position: relative;\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0;\n}\n.barcode[data-v-b9329428] {\n  font-size: 13px;\n}\n.product-info-second-col[data-v-b9329428] {\n  padding-left: 10px;\n  float: left;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  font-size: 14px;\n}\n.product-info-item-badge .badge[data-v-b9329428] {\n  vertical-align: top;\n}\n", ""]);

// exports


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ty93");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("vax7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MOIw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("EDhK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e348a290", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a7153d3\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserAuthentication.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a7153d3\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserAuthentication.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Mu/A":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("AJ8v");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("73e4a52e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c55dc398\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./modal.vue", function() {
     var newContent = require("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c55dc398\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./modal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "NF5n":
/***/ (function(module, exports) {

module.exports = EB;

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _vueResource = __webpack_require__("8+8L");

var _vueResource2 = _interopRequireDefault(_vueResource);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _bootstrapVue = __webpack_require__("e6fC");

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

__webpack_require__("rbrE");

__webpack_require__("9M+g");

__webpack_require__("qb6w");

__webpack_require__("VaBq");

var _vuexRouterSync = __webpack_require__("9JMe");

var _store = __webpack_require__("YtJ0");

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__("NYxO");

var _vueMoment = __webpack_require__("mjDs");

var _vueMoment2 = _interopRequireDefault(_vueMoment);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

_vue2.default.use(_bootstrapVue2.default);
_vue2.default.use(_vueResource2.default);
_vue2.default.use(_vueMoment2.default);

_moment2.default.locale('nl');

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

_vue2.default.http.interceptors.push(function (request, next) {
  request.withCredentials = true;

  next();
});

/* Logging is disabled for now
if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
  EB.Log.destinationURI = process.env.API_URL + '/zebra/log'
  EB.Log.destination = [EB.Log.DEST_FILE, EB.Log.DEST_URI]
  EB.Log.level = EB.Log.LEVEL_TRACE
  EB.Log.excludeCategories = ''
  EB.Log.netTrace = false
  EB.Log.skipPost = true

  EB.Log.cleanLogFile()

  let sendLogFile = () => {
    EB.Log.sendLogFile(() => {
      setTimeout(() => {
        sendLogFile()
      }, 1000)
    })
  }

  sendLogFile()
} */

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  store: _store2.default,
  router: _router2.default,
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('loading', ['isLoading', 'anyLoading'])),
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),

/***/ "OH6C":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7bLt");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("15684a46", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-23b234a4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./form-file.vue", function() {
     var newContent = require("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-23b234a4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./form-file.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "PvDG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n/* Special styling for type=range and type=color input */\ninput.form-control[type=\"range\"],\ninput.form-control[type=\"color\"] {\n    height: 2.25rem;\n}\ninput.form-control.form-control-sm[type=\"range\"],\ninput.form-control.form-control-sm[type=\"color\"] {\n    height: 1.9375rem;\n}\ninput.form-control.form-control-lg[type=\"range\"],\ninput.form-control.form-control-lg[type=\"color\"] {\n    height: 3rem;\n}\n/* Less padding on type=color */\ninput.form-control[type=\"color\"] {\n    padding: 0.25rem 0.25rem;\n}\ninput.form-control.form-control-sm[type=\"color\"] {\n    padding: 0.125rem 0.125rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "Qod3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid main-menu" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12 menu-item" },
        [
          _c("router-link", { attrs: { to: { name: "scan-produced" } } }, [
            _c("div", { staticClass: "btn btn-produced btn-full-width" }, [
              _c("div", { staticClass: "btn-first-line" }, [_vm._v("scannen")]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-primary-line" }, [
                _vm._v("GEPRODUCEERD")
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-12 menu-item" },
        [
          _c("router-link", { attrs: { to: { name: "scan-packing" } } }, [
            _c("div", { staticClass: "btn btn-pick btn-full-width" }, [
              _c("div", { staticClass: "btn-first-line" }, [_vm._v("scannen")]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-primary-line" }, [
                _vm._v("INPAKKEN")
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-12 menu-item" },
        [
          _c(
            "router-link",
            { attrs: { to: { name: "production-item-info" } } },
            [
              _c("div", { staticClass: "btn btn-item-info btn-full-width" }, [
                _c("div", { staticClass: "btn-first-line" }, [
                  _vm._v("scannen")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-primary-line" }, [
                  _vm._v("PRODUCTIE INFO")
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-12 menu-item" },
        [
          _c("router-link", { attrs: { to: { name: "packing-slip-info" } } }, [
            _c("div", { staticClass: "btn btn-shipping-info btn-full-width" }, [
              _c("div", { staticClass: "btn-first-line" }, [_vm._v("scannen")]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-primary-line" }, [
                _vm._v("PAKBON INFO")
              ])
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beffe230", esExports)
  }
}

/***/ }),

/***/ "RJNN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\na[data-v-38c5d5d3]:hover {\n  cursor: pointer;\n}\n.module-title[data-v-38c5d5d3] {\n  background-color: #ff8535;\n  color: #fff;\n  font-size: 20px;\n  line-height: 40px;\n}\na[data-v-38c5d5d3]:hover {\n  cursor: pointer;\n}\n.product-info[data-v-38c5d5d3] {\n  background-color: #fff;\n  margin-top: 15px;\n  padding: 10px;\n  width: 100%;\n}\n.product-info table[data-v-38c5d5d3] {\n  width: 100%;\n}\n.product-info table td[data-v-38c5d5d3],\n.product-info table th[data-v-38c5d5d3] {\n  vertical-align: top;\n}\n.main-menu[data-v-38c5d5d3] {\n  padding-top: 15px;\n}\n.btn-full-width[data-v-38c5d5d3] {\n  width: 100%;\n  margin-top: 15px;\n}\n.btn[data-v-38c5d5d3] {\n  cursor: pointer;\n  border-radius: 0;\n}\n.menu-item[data-v-38c5d5d3] {\n  margin-bottom: 15px;\n}\n.btn-first-line[data-v-38c5d5d3] {\n  font-size: 10px;\n  line-height: 10px;\n  vertical-align: top;\n}\n.btn-primary-line[data-v-38c5d5d3] {\n  font-size: 20px;\n  line-height: 26px;\n  vertical-align: top;\n}\n.btn-send[data-v-38c5d5d3] {\n  background-color: #ff8535;\n  color: #fff;\n}\n.btn-pick[data-v-38c5d5d3] {\n  background-color: #28a745;\n  color: #fff;\n}\n.btn-item-info[data-v-38c5d5d3] {\n  background-color: #17a2b8;\n  color: #fff;\n}\n", ""]);

// exports


/***/ }),

/***/ "RpPf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _EB = __webpack_require__("NF5n");

var _EB2 = _interopRequireDefault(_EB);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var barcodeOptions = {
  allDecoders: false,
  code128: true,
  code128securityLevel: 0,
  code39: true,
  code39securityLevel: 0,
  datamatrix: true,
  aimType: _EB2.default.Barcode.AIMTYPE_TRIGGER, // AIMTYPE_CONTINUOUS_READ
  decodeFrequency: 2000,
  decodeLEDFeedback: true,
  decodeLEDFeedbackMode: _EB2.default.Barcode.LEDMODE_BOTH,
  decodeLEDTime: 300,
  decodeVolume: 5,
  decodeDuration: 200,
  hapticFeedback: true,
  lcdMode: true,
  sameSymbolTimeout: 3000,
  differentSymbolTimeout: 0
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  created: function created() {
    if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
      this.scannerType = 'zebra';

      _EB2.default.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned);
      _EB2.default.Application.setApplicationNotify(this.onZebraApplicationDestroy);
    } else {
      this.scannerType = 'software';
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
      _EB2.default.Barcode.disable();
    }
  },
  data: function data() {
    return {
      packingSlip: null,
      error: null,
      barcode: null,
      scannerType: null,
      debug: null
    };
  },

  computed: {
    numPicked: function numPicked() {
      var numPicked = 0;

      if (!this.packingSlip) {
        return numPicked;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.packingSlip.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.packingStatus === 'picked' || item.packingStatus === 'packed') {
            ++numPicked;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return numPicked;
    }
  },
  methods: {
    onZebraApplicationDestroy: function onZebraApplicationDestroy(event) {
      switch (event.applicationEvent) {
        case _EB2.default.Application.APP_EVENT_ACTIVATED:
        case _EB2.default.Application.APP_EVENT_UICREATED:
        case _EB2.default.Application.APP_EVENT_SCREEN_ON:
          _EB2.default.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned);
          console.log('activated scanner 2');
          break;
        case _EB2.default.Application.APP_EVENT_SCREEN_OFF:
        case _EB2.default.Application.APP_EVENT_UIDESTROYED:
        case _EB2.default.Application.APP_EVENT_DEACTIVATED:
          _EB2.default.Barcode.disable();
          console.log('disabled scanner 2');
          break;
      }
    },
    zebraBarcodeScanned: function zebraBarcodeScanned(barcode) {
      if (this.packingSlip) {
        this.updateItemPackingStatus(barcode.data);
      } else {
        this.fetchPackingSlipInfo(barcode.data);
      }
    },
    updateItemPackingStatus: function updateItemPackingStatus(barcode) {
      var _this = this;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.packingSlip.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.productionReceipt.barcode === barcode) {
            this.$http.patch("https://scan-api.productie-test.drbanket.nl" + '/packing-slip/' + this.barcode + '/production-receipt/' + barcode + '/packing-status', {
              packingStatus: 'picked'
            }).then(function (response) {
              _this.packingSlip = response.body;
              _this.checkPackingSlipPickingStatus(_this.packingSlip);
            }, function (response) {
              // todo: handle errors
            });

            return;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    fetchPackingSlipInfo: function fetchPackingSlipInfo(barcode) {
      var _this2 = this;

      this.barcode = barcode;
      this.packingSlip = null;
      this.error = null;

      this.$http.get("https://scan-api.productie-test.drbanket.nl" + '/packing-slip/' + barcode).then(function (response) {
        if (response.body.pickingStatus === 'picked') {
          _this2.error = 'Deze pakbon is al verwerkt.';
        } else if (response.body.pickingStatus === 'not_started') {
          _this2.error = 'Deze pakbon is nog niet verwerkt door het systeem, print de pakbon uit via het systeem.';
        } else {
          _this2.packingSlip = response.body;
          _this2.checkPackingSlipPickingStatus(_this2.packingSlip);
        }
      }, function (response) {
        if (response.status === 0) {
          _this2.error = 'Kan geen informatie ophalen vanaf de server, controleer de internetverbinding.';
        } else if (response.status === 404) {
          _this2.error = 'Geen informatie gevonden voor ' + barcode + '.';
        } else {
          _this2.error = 'Er heeft zich een onbekende fout voorgedaan voor ' + barcode + '.';
        }
        // do nothing
      });
    },
    checkPackingSlipPickingStatus: function checkPackingSlipPickingStatus(packingSlip) {
      if (packingSlip.pickingStatus !== 'picking' || !this.areAllItemsPicked(packingSlip)) {
        return;
      }

      this.updatePackingSlipPackingStatus(packingSlip);
    },
    areAllItemsPicked: function areAllItemsPicked(packingSlip) {
      return this.numPicked === packingSlip.items.length;
    },
    updatePackingSlipPackingStatus: function updatePackingSlipPackingStatus(packingSlip) {
      var _this3 = this;

      this.$http.patch("https://scan-api.productie-test.drbanket.nl" + '/packing-slip/' + this.packingSlip.barcode + '/packing-status', {
        packingStatus: 'packed'
      }).then(function (response) {
        // all items packed, move to the next one
        setTimeout(function () {
          _this3.packingSlip = null;
          _this3.error = null;
          _this3.barcode = null;
        }, 3000);
      }, function (response) {
        // todo: handle errors
      });
    },
    getProductionStatusBadge: function getProductionStatusBadge(item) {
      switch (item.productionStatus) {
        case 'new':
          return '<span class="badge badge-production-status badge-new">Nieuw</span>';
        case 'cancelled':
          return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>';
        case 'preparing_for_production':
        case 'in_production':
          return '<span class="badge badge-production-status badge-in-production">In productie</span>';
        case 'produced':
          if (item.packingStatus === 'packed') {
            return '<span class="badge badge-production-status badge-packed">Ingepakt</span>';
          }

          return '<span class="badge badge-production-status badge-produced">Geproduceerd</span>';
        default:
          return item.productionStatus;
      }
    },
    getPickingStatusSequenceColorClass: function getPickingStatusSequenceColorClass(status) {
      switch (status) {
        case 'picked':
        case 'packed':
          return 'picked';
        default:
          return 'unpicked';
      }
    },
    getPackingStatusBadge: function getPackingStatusBadge(status) {
      switch (status) {
        case 'not_produced':
          return '<span class="badge badge-production-status badge-new">Nieuw</span>';
        case 'unpicked':
          return '<span class="badge badge-production-status badge-in-production">Verzamelen...</span>';
        case 'picked':
          return '<span class="badge badge-production-status badge-produced">Verzameld</span>';
        case 'packed':
          return '<span class="badge badge-production-status badge-packed">Ingepakt</span>';
        case 'cancelling':
          return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>';
        case 'cancelled':
          return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>';
        default:
          return status;
      }
    },
    getPickingStatusBadge: function getPickingStatusBadge(status) {
      switch (status) {
        case 'not_started':
          return '<span class="badge badge-production-status badge-new">Nieuw</span>';
        case 'picking':
          return '<span class="badge badge-production-status badge-produced">Verzamelen...</span>';
        case 'picked':
          return '<span class="badge badge-production-status badge-packed">Ingepakt</span>';
        default:
          return status;
      }
    },
    getPrintStatusBadge: function getPrintStatusBadge(status) {
      switch (status) {
        case 'unprinted':
          return '<span class="badge badge-production-status badge-unprinted">Niet geprint</span>';
        case 'preparing':
          return '<span class="badge badge-production-status badge-printing">Wordt geprint...</span>';
        case 'printed':
          return '<span class="badge badge-production-status badge-printed">Geprint</span>';
        default:
          return status;
      }
    }
  }
};

/***/ }),

/***/ "S3FR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAuthentication_vue__ = __webpack_require__("WWL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAuthentication_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAuthentication_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAuthentication_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAuthentication_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c5d5d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientAuthentication_vue__ = __webpack_require__("r8GP");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("jpVf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38c5d5d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAuthentication_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c5d5d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientAuthentication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ClientAuthentication.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38c5d5d3", Component.options)
  } else {
    hotAPI.reload("data-v-38c5d5d3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SVxk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  created: function created() {},

  computed: {},
  methods: {}
};

/***/ }),

/***/ "Tpvn":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("PvDG");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1aa8f07b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-23cbccf8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./form-input.vue", function() {
     var newContent = require("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-23cbccf8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./form-input.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "TsXW":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("XG+u");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("46526fe3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ab6b6e5e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ScanProduced.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ab6b6e5e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ScanProduced.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Ty93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.clientAuthenticated === false
    ? _c("div", [_c("client-authentication")], 1)
    : _vm.clientAuthenticated === true && _vm.userAuthenticated === false
      ? _c("div", [_c("user-authentication")], 1)
      : _vm.clientAuthenticated === true && _vm.userAuthenticated === true
        ? _c("div", [_c("router-view")], 1)
        : _c("div")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}

/***/ }),

/***/ "UgVW":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1F9u");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("d516ecea", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-beffe230\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MainMenu.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-beffe230\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MainMenu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "VaBq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WWL2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},
  data: function data() {
    return {
      clientRequest: null,
      clientHostname: '',
      requestError: '',
      clientRequestExpired: null
    };
  },

  computed: {},
  methods: {
    requestClientAccess: function requestClientAccess() {
      var _this = this;

      this.$http.post("https://scan-api.productie-test.drbanket.nl" + '/scanner-client-request', { clientName: this.clientHostname }, { withCredentials: true }).then(function (response) {
        _this.clientRequest = response.body;
        _this.clientRequestExpired = false;

        if (!_this.clientRequest.certificate.signed) {
          setTimeout(function () {
            _this.refreshClientRequestStatus();
          }, 10000);
        }
      }, function (response) {
        _this.requestError = response.errors.join(',');
      });
    },
    refreshClientRequestStatus: function refreshClientRequestStatus() {
      var _this2 = this;

      this.$http.get("https://scan-api.productie-test.drbanket.nl" + '/scanner-client-request/' + this.clientRequest.requestSecret, { withCredentials: true }).then(function (response) {
        _this2.clientRequest = response.body;

        if (!_this2.clientRequest.certificate.signed) {
          setTimeout(function () {
            _this2.refreshClientRequestStatus();
          }, 10000);
        }
      }, function () {
        _this2.clientRequestExpired = true;
      });
    },
    downloadCertificateChain: function downloadCertificateChain() {
      window.open("https://scan-api.productie-test.drbanket.nl" + '/' + this.clientRequest.certificate.certificateChain, 'download_window');
      window.focus();
    },
    downloadPkcs12certificate: function downloadPkcs12certificate() {
      window.open("https://scan-api.productie-test.drbanket.nl" + '/' + this.clientRequest.certificate.pkcs12, 'download_window');
      window.focus();
    },
    resetClientRequest: function resetClientRequest() {
      this.clientRequest = null;
      this.clientHostname = '';
      this.requestError = null;
      this.clientRequestExpired = null;
    }
  }
};

/***/ }),

/***/ "XG+u":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\na[data-v-ab6b6e5e]:hover {\n  cursor: pointer;\n}\n.module-title[data-v-ab6b6e5e] {\n  background-color: #ff8535;\n  color: #fff;\n  font-size: 20px;\n  line-height: 40px;\n  margin-bottom: 15px;\n}\n.product-info[data-v-ab6b6e5e] {\n  background-color: #fff;\n  margin-bottom: 15px;\n  padding: 10px;\n  width: 100%;\n}\n.product-info table[data-v-ab6b6e5e] {\n  width: 100%;\n}\n.product-info table td[data-v-ab6b6e5e] {\n  vertical-align: top;\n}\n.product-info .badge[data-v-ab6b6e5e] {\n  vertical-align: text-bottom;\n}\n.text-left[data-v-ab6b6e5e] {\n  text-align: left;\n}\n.text-center[data-v-ab6b6e5e] {\n  text-align: center;\n}\n.text-right[data-v-ab6b6e5e] {\n  text-align: right;\n}\n.text-totals[data-v-ab6b6e5e] {\n  width: 33.333%;\n}\n", ""]);

// exports


/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _MainMenu = __webpack_require__("x7p7");

var _MainMenu2 = _interopRequireDefault(_MainMenu);

var _ProductionItemInfo = __webpack_require__("8aCK");

var _ProductionItemInfo2 = _interopRequireDefault(_ProductionItemInfo);

var _ScanPacking = __webpack_require__("6gam");

var _ScanPacking2 = _interopRequireDefault(_ScanPacking);

var _ScanProduced = __webpack_require__("2u8u");

var _ScanProduced2 = _interopRequireDefault(_ScanProduced);

var _PackingSlipInfo = __webpack_require__("Iwyp");

var _PackingSlipInfo2 = _interopRequireDefault(_PackingSlipInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  mode: 'history',
  base: "/",
  routes: [{
    path: '/',
    name: 'main-menu',
    component: _MainMenu2.default
  }, {
    path: '/production-item-info',
    name: 'production-item-info',
    component: _ProductionItemInfo2.default
  }, {
    path: '/packing-slip-info',
    name: 'packing-slip-info',
    component: _PackingSlipInfo2.default
  }, {
    path: '/scan-packing',
    name: 'scan-packing',
    component: _ScanPacking2.default
  }, {
    path: '/scan-produced',
    name: 'scan-produced',
    component: _ScanProduced2.default
  }]
});

/***/ }),

/***/ "YtJ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _vueMoment = __webpack_require__("mjDs");

var _vueMoment2 = _interopRequireDefault(_vueMoment);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _vuexLoading = __webpack_require__("W/lP");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VuexLoading = (0, _vuexLoading.createVuexLoader)({
  moduleName: 'loading',
  componentName: 'v-loading',
  className: 'v-loading'
});

_vue2.default.use(_vuex2.default);
_vue2.default.use(VuexLoading);
_vue2.default.use(_vueMoment2.default);

exports.default = new _vuex2.default.Store({
  plugins: [VuexLoading.Store],
  state: {
    client: null,
    user: null,
    session: null,
    userAuthenticated: null,
    clientAuthenticated: null
  },
  mutations: {
    SET_CLIENT_AUTHENTICATION: function SET_CLIENT_AUTHENTICATION(state, client) {
      state.client = client;
      state.clientAuthenticated = true;
    },
    CLEAR_CLIENT_AUTHENTICATION: function CLEAR_CLIENT_AUTHENTICATION(state) {
      state.client = null;
      state.clientAuthenticated = false;
    },
    SET_USER_SESSION: function SET_USER_SESSION(state, session) {
      state.user = session.user;
      state.session = session;
      state.userAuthenticated = true;
    },
    CLEAR_USER_SESSION: function CLEAR_USER_SESSION(state) {
      state.userAuthenticated = false;
      state.user = null;
      state.session = null;
    }
  },
  getters: {},
  actions: {
    authenticate: function authenticate(_ref, data) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      return new _promise2.default(function (resolve, reject) {
        _vue2.default.http.post("https://scan-api.productie-test.drbanket.nl" + '/user-session', {
          username: data.username,
          code: data.code
        }, { withCredentials: true }).then(function (response) {
          var session = response.body;

          session.expiresAfter = (0, _moment2.default)().add(_moment2.default.duration(session.expiresIn));
          delete session.expiresIn;

          setTimeout(function () {
            dispatch('refreshAuthentication').then(function () {}, function () {});
          }, session.expiresAfter.diff((0, _moment2.default)()) + 1000);

          commit('SET_USER_SESSION', session);
          resolve();
        }, function (response) {
          commit('CLEAR_USER_SESSION');
          reject(response.body.errors);
        });
      });
    },
    refreshAuthentication: function refreshAuthentication(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      return new _promise2.default(function (resolve, reject) {
        _vue2.default.http.get("https://scan-api.productie-test.drbanket.nl" + '/user-session', { withCredentials: true }).then(function (response) {
          var session = response.body;

          session.expiresAfter = (0, _moment2.default)().add(_moment2.default.duration(session.expiresIn));
          delete session.expiresIn;

          setTimeout(function () {
            dispatch('refreshAuthentication').then(function () {}, function () {});
          }, session.expiresAfter.diff((0, _moment2.default)()) + 1000);

          commit('SET_USER_SESSION', session);
          resolve();
        }, function (response) {
          commit('CLEAR_USER_SESSION');
          reject(response.body.errors);
        });
      });
    },
    refreshClientAuthentication: function refreshClientAuthentication(_ref3) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _vue2.default.http.get("https://scan-api.productie-test.drbanket.nl" + '/scanner-client', { withCredentials: true }).then(function (response) {
          var data = response.body;

          if (data.status === 'client_found') {
            commit('SET_CLIENT_AUTHENTICATION', data.client);
            resolve();
          } else {
            commit('CLEAR_CLIENT_AUTHENTICATION');
            reject([data.status]);
          }
        }, function (response) {
          commit('CLEAR_CLIENT_AUTHENTICATION');
          reject(response.body.errors);
        });
      });
    }
  }
});

/***/ }),

/***/ "aPSQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal = __webpack_require__("rKsW");

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _modal2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "calG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [_vm._v("LOGIN")]),
      _vm._v(" "),
      !_vm.firstLetter
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "name-description" }, [
              _vm._v("\n        Wat is je naam?\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "letter-container" },
              _vm._l(_vm.letters, function(letter) {
                return _c(
                  "div",
                  {
                    staticClass: "letter-box",
                    on: {
                      click: function($event) {
                        _vm.selectFirstLetter(letter)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "letter-btn",
                        class: {
                          available: _vm.possibleLetters.indexOf(letter) !== -1
                        }
                      },
                      [
                        _c(
                          "table",
                          { staticStyle: { width: "100%", height: "100%" } },
                          [
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "vertical-align": "middle"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(letter) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              })
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.firstLetter && !_vm.user
        ? _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("div", { staticClass: "name-description" }, [
                _vm._v("\n        Wat is je naam?\n      ")
              ]),
              _vm._v(" "),
              _vm._l(_vm.selectedUsers, function(user) {
                return _c(
                  "div",
                  {
                    staticClass: "user-username",
                    on: {
                      click: function($event) {
                        _vm.selectUser(user)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(user.firstName) +
                        " " +
                        _vm._s(user.lastName) +
                        "\n      "
                    )
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.user
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "user-username" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.user.firstName) +
                  " " +
                  _vm._s(_vm.user.lastName)
              ),
              _c("br")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-username" }, [
              _vm._v("\n        Toegangscode:"),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "code" }, [
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 0 ? "*" : "")
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 1 ? "*" : "")
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 2 ? "*" : "")
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 3 ? "*" : "")
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 4 ? "*" : "")
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "number-input-block" }, [
                _c(
                  "table",
                  {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { cellpadding: "1", cellspacing: "0" }
                  },
                  [
                    _c("tr", [
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("1")
                              }
                            }
                          },
                          [_vm._v("1")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("2")
                              }
                            }
                          },
                          [_vm._v("2")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("3")
                              }
                            }
                          },
                          [_vm._v("3")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("4")
                              }
                            }
                          },
                          [_vm._v("4")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("5")
                              }
                            }
                          },
                          [_vm._v("5")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("6")
                              }
                            }
                          },
                          [_vm._v("6")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("7")
                              }
                            }
                          },
                          [_vm._v("7")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("8")
                              }
                            }
                          },
                          [_vm._v("8")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("9")
                              }
                            }
                          },
                          [_vm._v("9")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td"),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("0")
                              }
                            }
                          },
                          [_vm._v("0")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.removeNumberCode()
                              }
                            }
                          },
                          [_vm._v("⇐")]
                        )
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a7153d3", esExports)
  }
}

/***/ }),

/***/ "dYJE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\na[data-v-32d1e6d7]:hover {\n  cursor: pointer;\n}\n.module-title[data-v-32d1e6d7] {\n  background-color: #17a2b8;\n  color: #fff;\n  font-size: 20px;\n  line-height: 40px;\n}\na[data-v-32d1e6d7]:hover {\n  cursor: pointer;\n}\n.product-info[data-v-32d1e6d7] {\n  background-color: #fff;\n  margin-top: 15px;\n  padding: 10px;\n  width: 100%;\n}\n.product-info table[data-v-32d1e6d7] {\n  width: 100%;\n}\n.product-info table td[data-v-32d1e6d7],\n.product-info table th[data-v-32d1e6d7] {\n  vertical-align: top;\n}\n.product-info.error[data-v-32d1e6d7] {\n  background-color: #dc3545;\n  color: #fff;\n}\n.sequence-number[data-v-32d1e6d7] {\n  display: inline-block;\n  font-size: 40px;\n  font-weight: bold;\n  line-height: 100px;\n  width: 100px;\n  height: 100px;\n  text-align: center;\n}\n.sequence-number.unpicked[data-v-32d1e6d7] {\n  background-color: #ff9999;\n  color: #000;\n}\n.sequence-number.picked[data-v-32d1e6d7] {\n  background-color: #99ff99;\n  color: #000;\n}\n.product-info-cols[data-v-32d1e6d7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.product-info-first-col[data-v-32d1e6d7] {\n  width: 100px;\n  text-align: center;\n  float: left;\n  position: relative;\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0;\n}\n.barcode[data-v-32d1e6d7] {\n  font-size: 13px;\n}\n.product-info-second-col[data-v-32d1e6d7] {\n  padding-left: 10px;\n  float: left;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  font-size: 14px;\n}\n.product-info-item-badge .badge[data-v-32d1e6d7] {\n  vertical-align: top;\n}\n", ""]);

// exports


/***/ }),

/***/ "eQr8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [
        _vm._v("GEPRODUCEERD")
      ]),
      _vm._v(" "),
      _vm.debug
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _vm._v("\n        " + _vm._s(_vm.debug) + "\n      ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-12" }, [
        _vm.items.length === 0 && _vm.fetchingItems.length === 0
          ? _c("div", { staticClass: "product-info" }, [
              _vm._v(
                "\n        Scan een barcode om aan te geven dat een item geproduceerd is. Je kan meerdere barcodes achter elkaar scannen.\n      "
              )
            ])
          : _c("div", { staticClass: "product-info" }, [
              _c("table", [
                _c("tr", [
                  _c("td", { staticClass: "text-left text-totals" }, [
                    _vm._v(
                      _vm._s(_vm.items.length + _vm.fetchingItems.length) +
                        " totaal"
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right text-totals" }, [
                    _vm._v(
                      _vm._s(_vm.items.length - _vm.numErrors) + " gescand"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "text-left text-totals" }, [
                    _vm._v(_vm._s(_vm.numScannedTwice) + " dubbel")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right text-totals" }, [
                    _vm._v(_vm._s(_vm.numErrors) + " fouten")
                  ])
                ])
              ])
            ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-12" },
        [
          _vm._l(_vm.fetchingItems, function(barcode) {
            return _c("div", { staticClass: "product-info" }, [
              _c("span", { staticClass: "item-loader float-left" }),
              _vm._v(" Verwerken " + _vm._s(barcode) + "\n      ")
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.items, function(item) {
            return _c("div", { staticClass: "product-info" }, [
              _c("table", [
                _c("tr", [
                  item.error
                    ? _c("td", [
                        _c(
                          "span",
                          {
                            staticClass:
                              "badge badge-production-status badge-error"
                          },
                          [_vm._v("Error")]
                        ),
                        _vm._v(" " + _vm._s(item.barcode))
                      ])
                    : _c("td", [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getProductionStatusBadge(item.item)
                            )
                          }
                        }),
                        _vm._v(" " + _vm._s(item.barcode))
                      ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  item.error
                    ? _c("td", [_vm._v(_vm._s(item.error))])
                    : _c("td", [
                        _vm._v(
                          _vm._s(item.item.product.productName) +
                            " " +
                            _vm._s(item.item.variation.variationName)
                        )
                      ])
                ])
              ])
            ])
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab6b6e5e", esExports)
  }
}

/***/ }),

/***/ "fcFS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formInput = __webpack_require__("qRo1");

var _formInput2 = _interopRequireDefault(_formInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _formInput2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "gRbd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("x/NQ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("12a340e0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25aff2b6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./table.vue", function() {
     var newContent = require("!!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25aff2b6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector.js?type=styles&index=0!./table.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jpVf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("RJNN");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("21fa2c56", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38c5d5d3\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClientAuthentication.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38c5d5d3\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClientAuthentication.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jxW3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [
        _vm._v("PAKBON INFO")
      ]),
      _vm._v(" "),
      !_vm.barcode && !_vm.packingSlip && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _vm._v(
                "\n        Scan een barcode om pakbon informatie weer te geven.\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.debug
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.debug) + "\n      ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.packingSlip && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("span", { staticClass: "item-loader float-left" }),
              _vm._v(
                " Ophalen informatie " + _vm._s(_vm.barcode) + "...\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && _vm.packingSlip && !_vm.error
        ? _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("div", { staticClass: "product-info" }, [
                _c("table", [
                  _c("tr", [
                    _c("th", [_vm._v("Status")]),
                    _vm._v(" "),
                    _c("td", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getPickingStatusBadge(
                            _vm.packingSlip.pickingStatus
                          )
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Barcode")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.packingSlip.barcode))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Ingepakt")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.numPicked) +
                          " / " +
                          _vm._s(_vm.packingSlip.items.length)
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.packingSlip.items, function(item) {
                return _c("div", { staticClass: "product-info" }, [
                  _c("div", { staticClass: "product-info-cols" }, [
                    _c("div", { staticClass: "product-info-first-col" }, [
                      item.productionReceipt.localReceiptInfo
                        ? _c(
                            "span",
                            {
                              staticClass: "sequence-number",
                              class: _vm.getPickingStatusSequenceColorClass(
                                item.packingStatus
                              )
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.productionReceipt.localReceiptInfo
                                    .sequenceNumber
                                )
                              )
                            ]
                          )
                        : _c("span", {
                            staticClass: "sequence-number",
                            class: _vm.getPickingStatusSequenceColorClass(
                              item.packingStatus
                            )
                          }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.getPackingStatusBadge(item.packingStatus)
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "barcode" }, [
                        _vm._v(_vm._s(item.productionReceipt.barcode))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-info-second-col" }, [
                      _c("span", {
                        staticClass: "product-info-item-badge",
                        domProps: {
                          innerHTML: _vm._s(_vm.getProductionStatusBadge(item))
                        }
                      }),
                      _c("br"),
                      _vm._v(" "),
                      _c("table", [
                        _c("tr", [
                          _c("td", { attrs: { colspan: "2" } }, [
                            _vm._v(
                              _vm._s(item.product.productName) +
                                " " +
                                _vm._s(item.variation.variationName)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("Productie:")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  item.productionDate,
                                  "DD-MM-YYYY"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("Aflevering:")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  item.deliveryDate,
                                  "DD-MM-YYYY"
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.packingSlip && _vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32d1e6d7", esExports)
  }
}

/***/ }),

/***/ "kIf6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("KQyE");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3df5a362", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b9329428\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ScanPacking.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b9329428\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ScanPacking.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kJiG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formFile = __webpack_require__("9NuQ");

var _formFile2 = _interopRequireDefault(_formFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _formFile2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__);
/* unused harmony namespace reexport */
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("9WQX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/bootstrap-vue/es/components/progress/progress.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-395cfa78", Component.options)
  } else {
    hotAPI.reload("data-v-395cfa78", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "r8GP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [
        _vm._v("REQUEST ACCESS")
      ]),
      _vm._v(" "),
      !_vm.clientRequest
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _c(
                "form",
                {
                  attrs: { method: "post" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.requestClientAccess()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "clientHostname" } }, [
                      _vm._v("Hostname")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.clientHostname,
                          expression: "clientHostname"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "clientHostname" },
                      domProps: { value: _vm.clientHostname },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.clientHostname = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      staticClass: "btn btn-send form-control",
                      attrs: { type: "submit", value: "Verzenden" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.requestClientAccess()
                        }
                      }
                    })
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clientRequest &&
      !_vm.clientRequest.certificate.signed &&
      !_vm.clientRequestExpired
        ? _c("div", { staticClass: "col-lg-12 menu-item" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm.clientRequest &&
      !_vm.clientRequest.certificate.signed &&
      _vm.clientRequestExpired
        ? _c("div", { staticClass: "col-lg-12 menu-item" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("p", [_vm._v("De aanvraag is verlopen.")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  staticClass: "btn btn-send form-control",
                  attrs: { type: "submit", value: "Verzenden" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.resetClientRequest()
                    }
                  }
                })
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clientRequest && _vm.clientRequest.certificate.signed
        ? _c("div", { staticClass: "col-lg-12 menu-item" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn btn-pick btn-full-width",
                on: {
                  click: function($event) {
                    _vm.downloadCertificateChain()
                  }
                }
              },
              [
                _c("div", { staticClass: "btn-first-line" }, [
                  _vm._v("download")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-primary-line" }, [
                  _vm._v("CERTIFICATE CHAIN")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn btn-item-info btn-full-width",
                on: {
                  click: function($event) {
                    _vm.downloadPkcs12certificate()
                  }
                }
              },
              [
                _c("div", { staticClass: "btn-first-line" }, [
                  _vm._v("download")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-primary-line" }, [
                  _vm._v("PKCS 12 CERTIFICATE")
                ])
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "product-info" }, [
      _c("p", [
        _vm._v(
          "Vraag een beheerder om de aanvraag te ondertekenen. De certificaten kunnen hier gedownload worden nadat de aanvraag is ondertekent."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "product-info" }, [
      _c("p", [
        _vm._v(
          "Download en installeer beide certificaten in de browser of in het besturingssysteem. Herstart na het installeren de browser."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38c5d5d3", esExports)
  }
}

/***/ }),

/***/ "rbrE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u65/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [
        _vm._v("PRODUCTIE INFO")
      ]),
      _vm._v(" "),
      !_vm.barcode && !_vm.item && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _vm._v(
                "\n        Scan een barcode om productie informatie weer te geven.\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.debug
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.debug) + "\n      ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.item && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("span", { staticClass: "item-loader float-left" }),
              _vm._v(
                " Ophalen informatie " + _vm._s(_vm.barcode) + "...\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && _vm.item && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("table", [
                _c("tr", [
                  _c("th", [_vm._v("Status")]),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      innerHTML: _vm._s(_vm.getProductionStatusBadge(_vm.item))
                    }
                  })
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Productiebon")]),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.item.productionReceipt
                          ? _vm.getPrintStatusBadge(
                              _vm.item.productionReceipt.printStatus
                            )
                          : ""
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Pakbon")]),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.item.packingSlip
                          ? _vm.getPrintStatusBadge(
                              _vm.item.packingSlip.printStatus
                            )
                          : ""
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Barcode")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.barcode))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Product")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.item.product.productName))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Variant")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.item.variation.variationName))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Productie datum")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.item.productionDate))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Aflever datum")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.item.deliveryDate))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Opties")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.item.logo
                      ? _c("span", [_vm._v("+ Logo"), _c("br")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.attachments.length > 0
                      ? _c("span", [_vm._v("+ Brief"), _c("br")])
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.item && _vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("td"), _vm._v(" "), _c("td")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4596736a", esExports)
  }
}

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vax7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("wULM");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("8774a1f2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "wULM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto+Slab);", ""]);

// module
exports.push([module.i, "\n", ""]);

// exports


/***/ }),

/***/ "x/NQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n/* Add support for fixed layout table */\ntable.b-table.b-table-fixed {\n    table-layout: fixed;\n}\n\n/* Busy table styling */\ntable.b-table[aria-busy=\"false\"] {\n    opacity: 1;\n}\ntable.b-table[aria-busy=\"true\"] {\n    opacity: .6;\n}\n\n/* Sort styling */\ntable.b-table>thead>tr>th,\ntable.b-table>tfoot>tr>th {\n    position: relative;\n}\ntable.b-table>thead>tr>th.sorting,\ntable.b-table>tfoot>tr>th.sorting {\n    padding-right: 1.5em;\n    cursor: pointer;\n}\ntable.b-table>thead>tr>th.sorting::before,\ntable.b-table>thead>tr>th.sorting::after,\ntable.b-table>tfoot>tr>th.sorting::before,\ntable.b-table>tfoot>tr>th.sorting::after {\n    position: absolute;\n    bottom: 0;\n    display: block;\n    opacity: 0.4;\n    padding-bottom: inherit;\n    font-size: inherit;\n    line-height: 180%\n}\ntable.b-table>thead>tr>th.sorting::before,\ntable.b-table>tfoot>tr>th.sorting::before {\n    right: 0.75em;\n    content: \"\\2191\";\n}\ntable.b-table>thead>tr>th.sorting::after,\ntable.b-table>tfoot>tr>th.sorting::after {\n    right: 0.25em;\n    content: \"\\2193\";\n}\ntable.b-table>thead>tr>th.sorting_asc::after,\ntable.b-table>thead>tr>th.sorting_desc::before,\ntable.b-table>tfoot>tr>th.sorting_asc::after,\ntable.b-table>tfoot>tr>th.sorting_desc::before {\n    opacity: 1;\n}\n\n/* stacked table layout */\n/* Derived from http://blog.adrianroselli.com/2017/11/a-responsive-accessible-table.html */\n/* Always stacked */\ntable.b-table.b-table-stacked {\n    width: 100%;\n}\ntable.b-table.b-table-stacked,\ntable.b-table.b-table-stacked>tbody,\ntable.b-table.b-table-stacked>tbody>tr,\ntable.b-table.b-table-stacked>tbody>tr>td,\ntable.b-table.b-table-stacked>tbody>tr>th,\ntable.b-table.b-table-stacked>caption {\n    display: block;\n}\n/* hide stuff we can't deal with, or shouldn't show */\ntable.b-table.b-table-stacked>thead,\ntable.b-table.b-table-stacked>tfoot,\ntable.b-table.b-table-stacked>tbody>tr.b-table-top-row,\ntable.b-table.b-table-stacked>tbody>tr.b-table-bottom-row {\n    display: none;\n}\n/* inter-row top border */\ntable.b-table.b-table-stacked>tbody>tr>:first-child {\n    border-top-width: .4rem;\n}\n/* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\ntable.b-table.b-table-stacked>tbody>tr>[data-label] {\n    display: grid;\n    grid-template-columns: 40% auto;\n    grid-gap: .25rem 1rem;\n}\n/* generate row cell \"heading\" */\ntable.b-table.b-table-stacked>tbody>tr>[data-label]::before {\n    content: attr(data-label);\n    display: inline;\n    text-align: right;\n    overflow-wrap: break-word;\n    font-weight: bold;\n    font-style: normal;\n}\n@media all and (max-width: 575.99px) {\n    /* Under SM */\ntable.b-table.b-table-stacked-sm {\n        width: 100%;\n}\ntable.b-table.b-table-stacked-sm,\n    table.b-table.b-table-stacked-sm>tbody,\n    table.b-table.b-table-stacked-sm>tbody>tr,\n    table.b-table.b-table-stacked-sm>tbody>tr>td,\n    table.b-table.b-table-stacked-sm>tbody>tr>th,\n    table.b-table.b-table-stacked-sm>caption {\n        display: block;\n}\n    /* hide stuff we can't deal with, or shouldn't show */\ntable.b-table.b-table-stacked-sm>thead,\n    table.b-table.b-table-stacked-sm>tfoot,\n    table.b-table.b-table-stacked-sm>tbody>tr.b-table-top-row,\n    table.b-table.b-table-stacked-sm>tbody>tr.b-table-bottom-row {\n        display: none;\n}\n    /* inter-row top border */\ntable.b-table.b-table-stacked-sm>tbody>tr>:first-child {\n        border-top-width: .4rem;\n}\n    /* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\ntable.b-table.b-table-stacked-sm>tbody>tr>[data-label] {\n        display: grid;\n        grid-template-columns: 40% auto;\n        grid-gap: .25rem 1rem;\n}\n    /* generate row cell \"heading\" */\ntable.b-table.b-table-stacked-sm>tbody>tr>[data-label]::before {\n        content: attr(data-label);\n        display: inline;\n        text-align: right;\n        overflow-wrap: break-word;\n        font-weight: bold;\n        font-style: normal;\n}\n}\n@media all and (max-width: 767.99px) {\n    /* under MD  */\ntable.b-table.b-table-stacked-md {\n        width: 100%;\n}\ntable.b-table.b-table-stacked-md,\n    table.b-table.b-table-stacked-md>tbody,\n    table.b-table.b-table-stacked-md>tbody>tr,\n    table.b-table.b-table-stacked-md>tbody>tr>td,\n    table.b-table.b-table-stacked-md>tbody>tr>th,\n    table.b-table.b-table-stacked-md>caption {\n        display: block;\n}\n    /* hide stuff we can't deal with, or shouldn't show */\ntable.b-table.b-table-stacked-md>thead,\n    table.b-table.b-table-stacked-md>tfoot,\n    table.b-table.b-table-stacked-md>tbody>tr.b-table-top-row,\n    table.b-table.b-table-stacked-md>tbody>tr.b-table-bottom-row {\n        display: none;\n}\n    /* inter-row top border */\ntable.b-table.b-table-stacked-md>tbody>tr>:first-child {\n        border-top-width: .4rem;\n}\n    /* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\ntable.b-table.b-table-stacked-md>tbody>tr>[data-label] {\n        display: grid;\n        grid-template-columns: 40% auto;\n        grid-gap: .25rem 1rem;\n}\n    /* generate row cell \"heading\" */\ntable.b-table.b-table-stacked-md>tbody>tr>[data-label]::before {\n        content: attr(data-label);\n        display: inline;\n        text-align: right;\n        overflow-wrap: break-word;\n        font-weight: bold;\n        font-style: normal;\n}\n}\n@media all and (max-width: 991.99px) {\n    /* under LG  */\ntable.b-table.b-table-stacked-lg {\n        width: 100%;\n}\ntable.b-table.b-table-stacked-lg,\n    table.b-table.b-table-stacked-lg>tbody,\n    table.b-table.b-table-stacked-lg>tbody>tr,\n    table.b-table.b-table-stacked-lg>tbody>tr>td,\n    table.b-table.b-table-stacked-lg>tbody>tr>th,\n    table.b-table.b-table-stacked-lg>caption {\n        display: block;\n}\n    /* hide stuff we can't deal with, or shouldn't show */\ntable.b-table.b-table-stacked-lg>thead,\n    table.b-table.b-table-stacked-lg>tfoot,\n    table.b-table.b-table-stacked-lg>tbody>tr.b-table-top-row,\n    table.b-table.b-table-stacked-lg>tbody>tr.b-table-bottom-row {\n        display: none;\n}\n    /* inter-row top border */\ntable.b-table.b-table-stacked-lg>tbody>tr>:first-child {\n        border-top-width: .4rem;\n}\n    /* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\ntable.b-table.b-table-stacked-lg>tbody>tr>[data-label] {\n        display: grid;\n        grid-template-columns: 40% auto;\n        grid-gap: .25rem 1rem;\n}\n    /* generate row cell \"heading\" */\ntable.b-table.b-table-stacked-lg>tbody>tr>[data-label]::before {\n        content: attr(data-label);\n        display: inline;\n        text-align: right;\n        overflow-wrap: break-word;\n        font-weight: bold;\n        font-style: normal;\n}\n}\n@media all and (max-width: 1199.99px) {\n    /* under XL  */\ntable.b-table.b-table-stacked-xl {\n        width: 100%;\n}\ntable.b-table.b-table-stacked-xl,\n    table.b-table.b-table-stacked-xl>tbody,\n    table.b-table.b-table-stacked-xl>tbody>tr,\n    table.b-table.b-table-stacked-xl>tbody>tr>td,\n    table.b-table.b-table-stacked-xl>tbody>tr>th,\n    table.b-table.b-table-stacked-xl>caption {\n        display: block;\n}\n    /* hide stuff we can't deal with, or shouldn't show */\ntable.b-table.b-table-stacked-xl>thead,\n    table.b-table.b-table-stacked-xl>tfoot,\n    table.b-table.b-table-stacked-xl>tbody>tr.b-table-top-row,\n    table.b-table.b-table-stacked-xl>tbody>tr.b-table-bottom-row {\n        display: none;\n}\n    /* inter-row top border */\ntable.b-table.b-table-stacked-xl>tbody>tr>:first-child {\n        border-top-width: .4rem;\n}\n    /* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\ntable.b-table.b-table-stacked-xl>tbody>tr>[data-label] {\n        display: grid;\n        grid-template-columns: 40% auto;\n        grid-gap: .25rem 1rem;\n}\n    /* generate row cell \"heading\" */\ntable.b-table.b-table-stacked-xl>tbody>tr>[data-label]::before {\n        content: attr(data-label);\n        display: inline;\n        text-align: right;\n        overflow-wrap: break-word;\n        font-weight: bold;\n        font-style: normal;\n}\n}\n\n/* Details row styling */\ntable.b-table>tbody>tr.b-table-details>td {\n    border-top: none;\n}\n", ""]);

// exports


/***/ }),

/***/ "x7p7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__ = __webpack_require__("SVxk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beffe230_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__ = __webpack_require__("Qod3");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("UgVW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-beffe230"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beffe230_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MainMenu.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-beffe230", Component.options)
  } else {
    hotAPI.reload("data-v-beffe230", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ClientAuthentication = __webpack_require__("S3FR");

var _ClientAuthentication2 = _interopRequireDefault(_ClientAuthentication);

var _UserAuthentication = __webpack_require__("4PwO");

var _UserAuthentication2 = _interopRequireDefault(_UserAuthentication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'app',
  components: {
    ClientAuthentication: _ClientAuthentication2.default,
    UserAuthentication: _UserAuthentication2.default
  },
  computed: {
    userAuthenticated: function userAuthenticated() {
      return this.$store.state.userAuthenticated;
    },
    clientAuthenticated: function clientAuthenticated() {
      return this.$store.state.clientAuthenticated;
    }
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('refreshClientAuthentication').then(function () {
      _this.$store.dispatch('refreshAuthentication').then(function () {}, function () {});
    }, function () {});
  }
};

/***/ }),

/***/ "xKc6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progress = __webpack_require__("E9Zr");

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _progress2.default; //
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "yel6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HCfX");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7169779e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4596736a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProductionItemInfo.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4596736a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProductionItemInfo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4a19104fe34f18cbb0fd.js